export const baseUrl = {
    baseDevUrl: 'https://gateway-frontend-external-test.ecarxgroup.com/',
    baseRealUrl: 'https://gateway-frontend-external.ecarxgroup.com/',
    fileUrl: 'magic-box/common/file/upload',
    staticUrl: 'magic-box/common/file/staticUrl',
    feedbackCreate: 'magic-box/feedback/create'
}